<template> 
    <div 
        v-if="!showLabels"
        :style="{
            cursor: 'url(' + pointerCursor + ', auto',
            height: imgRescaledSize[1] + 'px', 
            width: imgRescaledSize[0] + 'px',
            position: 'absolute',
            top: 0, 
            left: 0
            }"
        >
        
        <div 
            v-for="(item, index) in masks"
            :key="item.position[0]"
            >
            <div v-if="item" class="container-fluid">
                  <svg
                  :style="{ 
                      position: 'absolute',
                      left: item.position[0] + 'px',
                      top: item.position[1] + 'px',  
                      zIndex: 0,
                    }"
                    :xmlns="item.xmlns"
                    :height="item.size[1]"
                    :width="item.size[0]"
                    :viewBox="item.viewBox"
                    fill="none"
                    >
                    <path 
                        @click="toggleMaskVisible(index)" 
                        @mouseover="overMask()"
                        @mouseleave="leaveMask()"
                        :style="{ 
                            pointerEvents: 'all',
                            cursor: 'url(' + detailCursor + '), pointer'
                            }"
                        fill="none" 
                        :d="item.path" 
                        />
                  </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from '../main'
export default {
  name: "DetailMasks",
  props: ["galleries", "name", "showLabels"],
  data: function() {
    return {
      imgHeight: window.innerHeight,
      imgWidth: window.innerWidth,
      isMaskVisible: [],
      pointerCursor: require('@/assets/cursors/magnify.svg'),
      detailCursor: require('@/assets/cursors/detail.svg'),
      imgRescaledSize: [],
      scale: [1, 1]
    };
  },
  methods: {
    toggleMaskVisible(index) {
        this.isMaskVisible.splice(index, 1, !this.isMaskVisible[index]);
        bus.$emit('showLightbox', index);
    },
    overMask() {
        bus.$emit('overMask');
    },
    leaveMask() {
        bus.$emit('leaveMask');
    },
    setScaling() {
      let imgSizeRatio = (this.imgSize[0]/this.imgSize[1]);
      let screenRatio = window.innerWidth/window.innerHeight;
      let modHeight = this.imgSize[1] * (window.innerWidth/this.imgSize[0]);
      let modWidth = this.imgSize[0] * (window.innerHeight/this.imgSize[1]);
      let height = ((screenRatio > imgSizeRatio) ? modHeight : window.innerHeight);
      let width = ((screenRatio > imgSizeRatio) ? window.innerWidth : modWidth);
      this.imgRescaledSize = [width, height];
      this.scale = [width/this.imgSize[0], height/this.imgSize[1]];
    },
    setSvgSizePos(index) {
      let pos = this.galleries["galleries"][this.name][0]["items"][index]["mask"]["position"];
      let size = this.galleries["galleries"][this.name][0]["items"][index]["mask"]["size"];
      let sizeX = size[0] * this.scale[0];
      let sizeY = size[1] * this.scale[1];
      let newX = pos[0] * this.scale[0];
      let newY = pos[1] * this.scale[1];
      this.masks[index].size = [sizeX, sizeY];
      this.masks[index].position = [newX, newY];
    },
    updateSvgsSizePos() {
      this.setScaling();
      for (let i = 0; i < this.masks.length; i++) {
        this.setSvgSizePos(i);
      }
    }
  },
  computed: {
    imgSize: function() {
      return this.galleries["galleries"][this.name][0]["imageSize"];
    },
    image: function() {
      return require("@/assets/galleries/" + this.galleries["galleries"][this.name][0]["image"]);
    },
    items: function() {
       return this.galleries["galleries"][this.name][0]["items"];
    },
    masks: function() {
        let maskList = [];
        for (let i = 0; i < this.galleries["galleries"][this.name][0]["items"].length; i++) {
            let curMask = JSON.parse(JSON.stringify(this.galleries["galleries"][this.name][0]["items"][i]["mask"]));
            if (curMask) {
                maskList.push(curMask);
            }
        }
      return maskList;
    }
  },
  created() {
    window.addEventListener("resize", this.updateSvgsSizePos);
    this.setScaling();
    for (let i = 0; i < this.masks.length; i++) {
        this.isMaskVisible.push(false);
        this.setSvgSizePos(i);
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.updateSvgsSizePos);
  }
};
</script>

<style scoped>

.container-fluid {
  background-repeat: no-repeat;
  background-size: auto 100vh;
  /* height: 100vh; */
}

</style>
